import { render } from "./IconRenderer.vue?vue&type=template&id=359ce707"
import script from "./IconRenderer.vue?vue&type=script&lang=js"
export * from "./IconRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__